
export default {
  name: "Header",

  props: {
    appCfg: {
      type: Object,
      default: () => {
        return {}
      }
    },
    vars: {
      type: Object,
      default: () => {
        return {}
      }
    },
    menu: {
      type: Array,
      default: () => {
        return []
      }
    },
    dropdownMenus: {
      type: Array,
      default: () => {
        return []
      }
    },
    extraMenu: {
      type: Array,
      default: () => {
        return []
      }
    },
    hideCityInfo: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // Список соц. сетей
    socials: function () {
      let list = [];

      // if (this.vars?.["Почтовый адрес"]) {
      //   list.push({
      //     icon: require("~/assets/img/svg/socials/Mail.svg"),
      //     path: `mailto:${this.vars?.["Почтовый адрес"]}`,
      //     reachGoal: "nagatue_knopku_email "
      //   })
      // }
      if (this.appCfg?.telegram) {
        list.push({
          icon: require("~/assets/img/svg/socials/Telegram.svg"),
          path: this.appCfg?.telegram,
          reachGoal: "nagatue_knopku_telegram",
        })
      }
      if (this.appCfg?.viber) {
        list.push({
          icon: require("~/assets/img/svg/socials/Viber.svg"),
          path: this.appCfg?.viber,
          reachGoal: "",
        })
      }
      if (this.appCfg?.whatsapp) {
        list.push({
          icon: require("~/assets/img/svg/socials/WhatsAppGreen.svg"),
          path: this.appCfg?.whatsapp,
          reachGoal: "nagatue_knopku_whatsapp",
        })
      }
      if (this.appCfg?.max) {
        list.push({
          // иконка 30x30: PNG 72px (6 КБ) вместо 340-КБ SVG из Illustrator
          icon: require("~/assets/img/png/socials/max.png"),
          path: this.appCfg?.max,
          reachGoal: "nagatue_knopku_max",
        })
      }

      return list
    },

    currentCity(){
      return this.appCfg?.city?.data?.city_name || 'Екатеринбург'
    },

    getSubdomain() {
      const currHost = this.$store.getters['local-settings/currentHost'];
      return currHost ? `https://${currHost}` : 'https://centraltrans.ru/';
    },

    phoneNumber: function () {
      return this.$phoneFormat(this.vars?.['Телефон'])
    },

    emailAddress: function () {
      return this.vars?.["Почтовый адрес"]
    },
    whatsapp: function () {
      return this.appCfg?.whatsapp || ""
    },
    telegram: function () {
      const appCfg = this.$store.state?.appState?.config || {};
      return appCfg?.telegram
    },
  },

  components: {
    Search: () => import("~/components/Header/Search.vue"),
    CityInfo: () => import("~/components/Header/CityInfo.vue"),
    ExtraMenu: () => import("~/components/Header/ExtraMenu.vue"),
    DrodDownMenu: () => import("~/components/Header/DrodDownMenu.vue"),
    MainMenu: () => import("~/components/Header/MainMenu.vue"),
  },

  methods: {
    requestCall: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: 'Заказать звонок',
          hideTabs: true,
        }
      });
    },
    submitOrderCalculation: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: 'Заказать расчет',
          type: 'Заказать расчет',
          activeTab: "big",
          hideTabs: true,
        }
      });
    },
    submitApplication: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: "Оставить заявку",
          type: 'Оставить заявку'
        }
      });
    },
    openAuthorization: function () {
      const isAuth = Boolean(this.$store.state?.user?.user?.id);
      if (this.$store.state?.user?.user?.group?.name === 'Клиенты реферальной программы') {
        this.$router.push('/personal-account')
        return
      }
      if (isAuth) {
        this.$router.push('/distillation')
        return
      }
      this.$store.commit("authRegistration/setOpen", {
        name: "isOpenAuth",
        value: true
      })
    },
    openSidebar: function () {
      this.$store.commit("sidebar/setOpen", true);
    },
    openPopUpCity: function () {
      this.$store.commit("city-select/setOpen", true);
    },

    sendReachGoal: function (reachGoal) {
      if (!reachGoal) {
        return
      }

      this.$yandexMetrika.reachGoal(reachGoal);
      this.$yaglaaction(reachGoal);
    },
  }
}
